import { useState, useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import { cloneDeep } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { getJSONClaims, deleteSubFlowById, getTemplatizationFields, getTemplatedComponents } from '../../../store';
import { selectedLinks } from '../utils';
import { resolverStringValid } from './resolverSelector';

const useComponentUIHook = (data: any) => {
  const dispatch = useDispatch();
  const [originalData, setOriginalData] = useState<any>(data);
  const [modifiedData, setModifiedData] = useState<any>(data);
  const templateFields = useSelector(getTemplatizationFields);
  const templatedComponents = useSelector(getTemplatedComponents);
  const [templatizations, setTemplatizations] = useState<any>(
    Object.keys(templatedComponents).includes(data.id) ?
      templatedComponents[data.id].settings.reduce((tpzs: { [index: string]: any }, sField: string) => {
        templateFields[sField].nodeFields[data.id].fieldPaths.forEach((fieldPath: string) => {
          tpzs[fieldPath] = sField;
        });
        return tpzs;
      }, {}) :
      {}
  );
  const [modifiedTemplatizations, setModifiedTemplatizations] = useState<any>(
    Object.keys(templatedComponents).includes(data.id) ?
      templatedComponents[data.id].settings.reduce((tpzs: { [index: string]: any }, sField: string) => {
        templateFields[sField].nodeFields[data.id].fieldPaths.forEach((fieldPath: string) => {
          tpzs[fieldPath] = sField;
        });
        return tpzs;
      }, {}) :
      {}
  );
  const allClaims = useSelector(getJSONClaims);

  useEffect(() => {
    setOriginalData(data);
    setModifiedData(data);
  }, [data]);

  useEffect(() => {
  }, [templatizations, modifiedTemplatizations]);

  useEffect(() => {
    const _nTemps = Object.keys(templatedComponents).includes(data.id) ?
      templatedComponents[data.id].settings.reduce((tpzs: { [index: string]: any }, sField: string) => {
        templateFields[sField].nodeFields[data.id].fieldPaths.forEach((fieldPath: string) => {
          tpzs[fieldPath] = sField;
        });
        return tpzs;
      }, {}) :
      {};
    setTemplatizations(_nTemps);
    setModifiedTemplatizations(_nTemps);
  }, [templateFields, data]);

  const checkIfSameIgnoringSubFlows = (toIgnore?: string[]) => {
    const a = cloneDeep(originalData);
    const b = cloneDeep(modifiedData);
    if (toIgnore) {
      toIgnore.forEach((sfId) => {
        delete a[sfId];
        delete b[sfId];
      });
    }
    if (Object.keys(modifiedTemplatizations).some((k: string) => {
      if (!Object.keys(templatizations).includes(k)) {
        return (!!modifiedTemplatizations[k]);
      } else {
        return !isEqual(templatizations[k], modifiedTemplatizations[k]);
      }
    })) {
      return false;
    }
    switch (data.componentType) {
      case 'signIn':
        if (!modifiedData['links']['localAccountSignIn']) {
          delete a['usernameType'];
          delete a['username'];
          delete b['usernameType'];
          delete b['username'];
        }
        if (!a.hasOwnProperty('nodeLinks')) {
          a['nodeLinks'] = [];
        }
        return isEqual(a, b) ? true : false;
      case 'google':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'restAPI':
        delete a['parameter'];
        delete b['parameter'];
        return isEqual(a, b) ? true : false;
      case 'tokenIssuer':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'aadCreate':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'aadRead':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'aadUpdate':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'userInputPage':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'appInsights':
        delete a['attribute'];
        delete b['attribute'];
        return isEqual(a, b) ? true : false;
      case 'conditionals':
        delete a['condition'];
        delete b['condition'];
        return isEqual(a, b) ? true : false;
      case 'mfa':
        return isEqual(a, b) ? true : false;
      case 'sessionExists':
      case 'usernamePasswordValidation':
      default:
        return isEqual(a, b) ? true : false;
    }
  };

  const onDeleteSubFlow = (id: string, subFlowType: string) => {
    dispatch(deleteSubFlowById({ id: id, subFlowType: subFlowType }));
  };

  return {
    originalData,
    modifiedData,
    setModifiedData,
    allClaims,
    checkIfSameIgnoringSubFlows,
    onDeleteSubFlow,
    modifiedTemplatizations,
    setModifiedTemplatizations
  };
};
export default useComponentUIHook;
